import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import { siteInfo } from "../../data/mockData";

const Footer = () => {
  return (
    <footer className="bg-[#111111] text-white">
      {/* Main Footer */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-6">
              <img
                src={siteInfo.logo}
                alt={siteInfo.name}
                className="h-8 w-auto object-contain invert"
              />
            </Link>
            <p className="text-white/50 text-sm leading-relaxed mb-6"
              style={{ fontFamily: "'Inter', sans-serif" }}>
              {siteInfo.description}
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center border border-white/20 text-white/50 hover:border-[#c8a96e] hover:text-[#c8a96e] transition-all duration-300">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center border border-white/20 text-white/50 hover:border-[#c8a96e] hover:text-[#c8a96e] transition-all duration-300">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center border border-white/20 text-white/50 hover:border-[#c8a96e] hover:text-[#c8a96e] transition-all duration-300">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[12px] tracking-[0.2em] uppercase text-[#c8a96e] mb-6"
              style={{ fontFamily: "'Inter', sans-serif" }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              {[
                { label: "About Us", path: "/about-us" },
                { label: "Jewelry Manufacturing", path: "/jewelry-manufacturing" },
                { label: "Diamond Manufacturing", path: "/diamond-manufacturing" },
                { label: "Jewelry Collection", path: "/jewelry" },
                { label: "Loose Diamonds", path: "/diamonds" },
                { label: "Ethical Standards", path: "/ethical-standards" }
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-white/50 text-sm hover:text-[#c8a96e] transition-colors duration-300"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-[12px] tracking-[0.2em] uppercase text-[#c8a96e] mb-6"
              style={{ fontFamily: "'Inter', sans-serif" }}>
              Connect With Us
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Contact Us", path: "/contact-us" },
                { label: "Make an Appointment", path: "/make-an-appointment" }
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-white/50 text-sm hover:text-[#c8a96e] transition-colors duration-300"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-[12px] tracking-[0.2em] uppercase text-[#c8a96e] mb-6"
              style={{ fontFamily: "'Inter', sans-serif" }}>
              Contact Info
            </h4>
            <div className="space-y-4">
              <a href={`tel:${siteInfo.phone}`} className="flex items-center gap-3 text-white/50 text-sm hover:text-[#c8a96e] transition-colors duration-300">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span style={{ fontFamily: "'Inter', sans-serif" }}>{siteInfo.phone}</span>
              </a>
              <a href={`mailto:${siteInfo.email}`} className="flex items-center gap-3 text-white/50 text-sm hover:text-[#c8a96e] transition-colors duration-300">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span style={{ fontFamily: "'Inter', sans-serif" }}>{siteInfo.email}</span>
              </a>
              <div className="flex items-start gap-3 text-white/50 text-sm">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span style={{ fontFamily: "'Inter', sans-serif" }}>{siteInfo.address}</span>
              </div>
            </div>

            {/* Subscribe */}
            <div className="mt-8">
              <p className="text-[11px] tracking-[0.15em] uppercase text-white/40 mb-3"
                style={{ fontFamily: "'Inter', sans-serif" }}>
                Subscribe to our newsletter
              </p>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 bg-white/5 border border-white/10 px-4 py-2.5 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-[#c8a96e]/50 transition-colors"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                />
                <button className="px-4 py-2.5 bg-[#c8a96e] text-[#111111] text-[11px] tracking-[0.15em] uppercase font-medium hover:bg-[#d4b87a] transition-colors duration-300"
                  style={{ fontFamily: "'Inter', sans-serif" }}>
                  Sign Up
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs tracking-[0.1em]"
            style={{ fontFamily: "'Inter', sans-serif" }}>
            &copy; {new Date().getFullYear()} Astron Diamond. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="text-white/30 text-xs hover:text-[#c8a96e] transition-colors"
              style={{ fontFamily: "'Inter', sans-serif" }}>
              Privacy Policy
            </Link>
            <Link to="#" className="text-white/30 text-xs hover:text-[#c8a96e] transition-colors"
              style={{ fontFamily: "'Inter', sans-serif" }}>
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
